import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="23" height="12" viewBox="0 0 23 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.296 10.343a5.15 5.15 0 019.996 0H6.296zM11.294 1.284v2.059M3.573 3.857l1.544 1.545M17.47 5.402l1.545-1.545M1 10.343h21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);